module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/709e9ca35bae81964ab0b585a235fc25.png";